<template>
  <div class="ima-loading-spinner">
    <div class="ima-loading-spinner__icon"></div>
    <span class="ima-loading-spinner__label">{{label}}</span>
  </div>
</template>


<script>
export default {
  name: 'ima-loading-spinner',
  props: {
    label: {
      type: String,
      default: 'Loading...'
    }
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
@import '../scss/settings';

.ima-loading-spinner {
  display: flex;
  align-items: center;

  &__icon {
    animation: scale 1s infinite ease-in-out;
    width: 1.6em;
    height: 1.6em;
    background-color: $primary;
    border-radius: 100%;
  }

  &__label {
    margin-left: 0.4em;
  }

  @keyframes scale {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
      opacity: 0;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/LoadingSpinner.vue